<template>
<div class="accordion--container" :id="id">
    <slot></slot>
</div>
</template>

<script>
export default {
    props: {
        id: { type: String, default: null },
    },
}
</script>

<style lang='scss' scoped>
@import '~/assets/SCSS/Base/00_functions.scss';
@import '~/assets/SCSS/Base/01_variables.scss';
@import '~/assets/SCSS/Base/02_mixins.scss';

@import '~/assets/SCSS/Elements/accordion.scss';
</style>